<template>
	<div>
		<!-- <app-header></app-header> -->
		<div class="l-container contact">
			<div class="l-contact">
				<strong class="tit">Contact</strong>
				<div id="map" class="map"></div>
				<div class="l-pc">
					<div class="address">
						<strong>서울시 강남구 테헤란로 151 역삼하이츠빌딩 패스트파이브 405호</strong>
						<span class="address-detail">Yeoksam Heights Building, </span>
						151 Teheran-ro, Gangnam-gu, Seoul, (FASTFIVE 405)
						<div class="tel">
							<a href="tel:02-3218-3500">Tel +82.2.3218.3500</a>
							<span>Fax +82.2.3218.3600</span>
						</div>
						<div>
							<a href="mailto:contact@xeogen.com" class="email">contact@xeogen.com</a>
						</div>
					</div>
					<button class="btn-request-quotation" v-on:click.prevent="fnRequest()">
						견적의뢰
					</button>
					<!-- pc only -->
					<div class="brochure-download"></div>
					<!-- // pc only -->
				</div>
			</div>
		</div>
		<!-- <app-footer></app-footer> -->
	</div>
</template>
<script>
// import Header from './Header.vue';
// import Footer from './Footer.vue';
import { store } from "../data/store.js";
import loadScriptOnce from "load-script-once";
export default {
	metaInfo: {
		title: "Contact",
		meta: [
			{
				vmid: "description",
				name: "description",
				content: "제오젠의 위치, 전화번호 및 견적의뢰를 제공합니다.",
			},
		],
	},
	data() {
		return {
			map: null, // 지도 객체. 지도가 로드되면 할당됨.
			store,
			currentRoute: window.location.pathname,
		};
	},
	methods: {
		// 지도가 로드 완료되면 load 이벤트 발생
		onLoad(map) {
			this.map = map;
		},

		fnRequest: function () {
			//this.$router.push({path: '/request'});
			window.open(
				"/request",
				"request",
				"width=800,height=800,left=0,top=0,menubar=no,toolbar=no,location=no,status=no,resizable=no,scrollbars=yes"
			);
		},
	},
	mounted: function () {
		var brochureDownload = $(".sidemenu").find(".brochure-download").html();
		$(".contact").find(".brochure-download").empty().html(brochureDownload);
		loadScriptOnce(
			`//dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=2a25c8bbab0d9dda77499d392045d476`,
			(err) => {
				if (err) {
					console.error(err);
					return;
				}

				daum.maps.load(() => {
					var mapContainer = document.getElementById("map"), // 지도를 표시할 div
						mapOption = {
							//center: new daum.maps.LatLng(37.5117391, 127.04333187), // 지도의 중심좌표
							center: new daum.maps.LatLng(37.5009535, 127.0361629), // 지도의 중심좌표
							level: 5, // 지도의 확대 레벨
						};

					// 지도 그림
					var map = new daum.maps.Map(mapContainer, mapOption); // 지도를 생성합니다

					// 마커가 표시될 위치입니다
					// var markerPosition = new daum.maps.LatLng(37.511757, 127.043898);
					var markerPosition  = new daum.maps.LatLng(37.5010436, 127.0363028); 

					// 마커를 생성합니다
					var marker = new daum.maps.Marker({
						position: markerPosition,
					});

					// 마커가 지도 위에 표시되도록 설정합니다
					marker.setMap(map);

					// 아래 코드는 지도 위의 마커를 제거하는 코드입니다
					// marker.setMap(null);

					var num = 0;
					var clear;
					var clearDuration = 500;

					$(window).on("resize", function () {
						clearInterval(clear);
						clear = setInterval(markerPos, clearDuration);
					});

					function markerPos() {
						map.setCenter(mapOption.center);
					}
				});
			}
		);
		(function (w, d, a) {
			w.__beusablerumclient__ = {
				load: function (src) {
					var b = d.createElement("script");
					b.src = src;
					b.async = true;
					b.type = "text/javascript";
					d.getElementsByTagName("head")[0].appendChild(b);
				},
			};
			w.__beusablerumclient__.load(a);
		})(
			window,
			document,
			"//rum.beusable.net/script/b181210e135950u360/001c482d91"
		);
	},
	components: {
		//    'app-header': Header,
		//    'app-footer': Footer
	},
	created() {
		//console.log('xgcontact')
	},
};
</script>


// WEBPACK FOOTER //
// src/components/XgContact.vue